// extracted by mini-css-extract-plugin
module.exports = {"next":"NextButton_next__23Dnb","nextLink":"NextButton_nextLink__1QqfY"};